/* ============================================================
   PAIR IT WITH — component-pair-it-with.js
   ============================================================ */

class PairItWith extends HTMLElement {
  connectedCallback() {
    this.track    = this.querySelector('[data-piw-track]');
    this.prevBtn  = this.querySelector('[data-piw-prev]');
    this.nextBtn  = this.querySelector('[data-piw-next]');
    this.items    = Array.from(this.querySelectorAll('[data-piw-item]'));

    if (!this.track || this.items.length === 0) return;

    this.index = 0;

    this.prevBtn.addEventListener('click', () => this.move(-1));
    this.nextBtn.addEventListener('click', () => this.move(1));

    // Keyboard support on the viewport
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.move(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.move(1); }
    });

    // Recalculate on resize (debounced)
    this._onResize = this._debounce(() => {
      this.index = 0;
      this._update();
    }, 200);
    window.addEventListener('resize', this._onResize);

    this._update();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  /** Returns how many full items are visible at once */
  get visibleCount() {
    if (!this.items[0]) return 1;
    const trackW = this.track.parentElement.offsetWidth;
    const itemW  = this.items[0].offsetWidth;
    return Math.max(1, Math.floor(trackW / itemW));
  }

  get maxIndex() {
    return Math.max(0, this.items.length - this.visibleCount);
  }

  move(delta) {
    this.index = Math.min(Math.max(this.index + delta, 0), this.maxIndex);
    this._update();
  }

  _update() {
    const itemW = this.items[0] ? this.items[0].offsetWidth : 0;
    const gap   = parseFloat(getComputedStyle(this.track).gap) || 0;
    const offset = this.index * (itemW + gap);

    this.track.style.transform = `translateX(-${offset}px)`;

    this.prevBtn.disabled = this.index === 0;
    this.nextBtn.disabled = this.index >= this.maxIndex;

    // Announce position to screen readers
    this.prevBtn.setAttribute('aria-label', `Previous products (${this.index} of ${this.maxIndex})`);
    this.nextBtn.setAttribute('aria-label', `Next products (${this.index} of ${this.maxIndex})`);
  }

  _debounce(fn, ms) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }
}

if (!customElements.get('pair-it-with')) {
  customElements.define('pair-it-with', PairItWith);
}
